import { useEffect, useState } from 'react';
import OnelivePageLayout from './OnelivePageLayout';
import OneliveSubPageLayout from './OneliveSubPageLayout';
import {
  NoticePostsData,
  fetchNoticePosts,
  navigate,
} from './api';

export default function NoticeBoardPage() {
  const [postsData, setPostsData] = useState<NoticePostsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const result = await fetchNoticePosts({ page });
        if (mounted) setPostsData(result);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [page]);

  const posts = postsData?.data ?? [];
  const lastPage = postsData?.pagination?.last_page ?? 1;
  const currentPage = postsData?.pagination?.current_page ?? page;

  return (
    <OnelivePageLayout pageClassName="onelive-notice-page">
      <OneliveSubPageLayout title="공지사항">
        {loading ? (
          <p className="onelive-sub-loading">로딩 중...</p>
        ) : posts.length === 0 ? (
          <p className="onelive-sub-empty">등록된 공지사항이 없습니다.</p>
        ) : (
          <div className="onelive-notice-list-wrap">
            <table className="onelive-notice-table-simple">
              <caption>공지사항 List</caption>
              <tbody>
                {posts.map((post) => (
                  <tr key={post.id}>
                    <td>
                      <button
                        type="button"
                        className="onelive-notice-row-link"
                        onClick={() => navigate(`/board/notice/${post.id}`)}
                      >
                        {post.title}
                      </button>
                      <span className="onelive-notice-heart" aria-hidden="true">♥</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {lastPage > 1 ? (
          <div className="onelive-sub-paging">
            <button
              type="button"
              disabled={currentPage <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              이전
            </button>
            <span>{currentPage} / {lastPage}</span>
            <button
              type="button"
              disabled={currentPage >= lastPage}
              onClick={() => setPage((p) => p + 1)}
            >
              다음
            </button>
          </div>
        ) : null}
      </OneliveSubPageLayout>
    </OnelivePageLayout>
  );
}
